import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import * as L from 'leaflet';
import { icon, marker, popup } from 'leaflet';
import { environment } from 'src/environments/environment';
import { TrackerService } from '../data/tracker.service';

@Injectable()
export class MapService implements OnDestroy {

    private baseUrl: string;
    map;
    markerUpdater;
    constructor(
        private http: HttpClient,
        private trackerService: TrackerService
    ) {
        this.baseUrl = environment.baseUrl
    }

    setMap(map) {
        this.map = map;
        this.markerUpdater = setInterval(() => {
            this.trackerService.getLastPositionPerTracker(sessionStorage.getItem('region'))
                .subscribe((res: any) => {
                    this.cleanLayers();
                    for (let i = 0; i < res.length; i++) {
                        this.createMarker(res[i].data, "");
                    }
                })
        }, 10000);
    }

    onDestroy() {
        clearInterval(this.markerUpdater);
    }

    getMap() {
        return this.map;
    }

    moveMap(point, zoom, offsetToBeAdd) {
        if (offsetToBeAdd) {
            var offset = this.map.getSize().x * 0.10;
            offset = offset / 1000;
            this.map.setView([point[0], point[1] + offset], zoom, { animation: true });
        } else {
            this.map.setView(point, zoom, { animation: true });
        }
    }

    cleanLayers() {
        this.map.eachLayer((layer) => {
            if (layer._popup) layer.remove();
        });
    }

    drawSingleMarker(markerToCreate) {
        clearInterval(this.markerUpdater);
        this.cleanLayers();
        this.createMarker(markerToCreate, "");
    }

    drawMarkers() {
        this.cleanLayers();
        this.trackerService.getLastPositionPerTracker(sessionStorage.getItem('region'))
            .subscribe((res: any) => {
                this.cleanLayers();
                for (let i = 0; i < res.length; i++) {
                    this.createMarker(res[i].data, "");
                    if (i + 1 == res.length) this.moveMap([43.35, 13.0], 9, false);
                }
            })
        this.markerUpdater = setInterval(() => {
            this.trackerService.getLastPositionPerTracker(sessionStorage.getItem('region'))
                .subscribe((res: any) => {
                    this.cleanLayers();
                    for (let i = 0; i < res.length; i++) {
                        this.createMarker(res[i].data, "");
                    }
                })
        }, 10000);
    }

    createMarker(markerToCreate, markerNumber) {
        const markerHtmlStyles = "background-color:#a6161f;width: 1.5rem;height: 1.5rem;display: block;left: -0.8rem;top: -1.2rem;position: relative;border-radius: 3rem 3rem 0;transform: rotate(45deg);border: 1px solid #393939"
        const divNumbered = "<div style='position: absolute;right: 30%;left: 32%;font-size: 18px;transform: rotate(315deg);'>" + markerNumber + "</div>"
        let popupContent = "";
        if (markerNumber == "") {
            popupContent = "<b>" + markerToCreate.aliasName + "</b><br>"
                + "Latitudine: <b>" + markerToCreate.latitude + "</b><br>"
                + "Longitudine: <b>" + markerToCreate.longitude + "</b><br>"
                + "<b>" + new Date(markerToCreate.dateTime).toLocaleString() + "</b>";
        } else {
            popupContent = "<b>" + markerToCreate.aliasName + "</b><br>"
                + "Posizione N: <b>" + markerNumber + "</b><br>"
                + "Latitudine: <b>" + markerToCreate.latitude + "</b><br>"
                + "Longitudine: <b>" + markerToCreate.longitude + "</b><br>"
                + "<b>" + new Date(markerToCreate.dateTime).toLocaleString() + "</b>"
        }
        const iconC = L.divIcon({
            iconAnchor: [0, 24],
            popupAnchor: [0, -36],
            html: '<span style=" ' + markerHtmlStyles + ' " >' + divNumbered + '</span>'
        })
        let poputToBind = popup(
            {
                closeButton: true,
                autoClose: false,
            })
        poputToBind.setContent(popupContent);

        marker(
            [markerToCreate.latitude, markerToCreate.longitude],
            { icon: iconC }
        ).addTo(this.getMap())
            .bindPopup(poputToBind).openPopup()
    }

    ngOnDestroy() {
        clearInterval(this.markerUpdater);
    }
}